/**
 *    @author: Andrew Sheen
 *    @since:  2020-10-30
 */

import { Component,OnInit,  AfterViewInit, ElementRef,Input,Output, EventEmitter, ViewEncapsulation,ViewChild } from '@angular/core';
import { Util } from '../../service/Util';
import { ControlBaseComponent } from "../control-base.component";
import { TimerService } from 'src/refresh/service/timer-service';
import { InputComponent } from '../input/input.component';


@Component({ 
  selector: 'ng-date',
  templateUrl: './input-date.component.html',
  styleUrls: ['./input-date.component.less'],
  encapsulation: ViewEncapsulation.None
})       
export class InputDateComponent extends ControlBaseComponent implements OnInit, AfterViewInit {
       //--------------------------------------------------------------------
       constructor(private elRef:ElementRef,protected timerService:TimerService) { 
             super(timerService,4); 
       }  

       private static id_no:number = 1;
       //--------------------------------------------------------------------
       @Output('update') changeHandler = new EventEmitter<string>();

       @Input('months')       months:Object;
       @Input('head-class')   headClass: string;
       @Input('head-style')   headStyle: string;
       @Input("space-between") spaceBetween = "space-between";
       @Input("space-end")     spaceEnd     = "space-end";
       @Input('title-year')    tooltipYear2: string = "";

       @Input('alt-year')     tooltipYY: string = "";
       @Input('alt-month')    tooltipMM: string = "";
       @Input('alt-day')      tooltipDD: string = "";

       public DD:string = "";
       public MM:string = "";
       public YY:number;

       public days : Map<string,string> = new Map();;

       public get inputClass():string {
              return this.input_class;
       }

       public get labelClass():string {
              return this.label_class;
       }

       public get className():string {
            return this.class_name;
       }

        public ngOnInit(): void {

            this.class_name = "control-margin";

            if ( !this.tooltipYY ) {
                  this.tooltipYY = this.tooltipYear2;
            }

            if ( !this.id ) {
                  this.id =  "radio1_"+InputDateComponent.id_no++;
            }

            for ( let i = 1; i <= 31; i++ ) {
                  let day = Util.padZero(String(i),2);
                  this.days.set(day,day);
            }

            if ( this.input ) {

                 let  values = this.input.split("-");
                 if ( values.length == 3 ) {

                      this.MM = values[1];
                      this.DD = values[2];

                      if ( values[0] ) { 
                           this.YY = Number(values[0]);
                           if ( this.YY == 0 ) this.YY = null;
                      }

                      if ( this.MM == '0' ) this.MM = '';
                      if ( this.DD == '0' ) this.DD = '';
                 }
            }

            super.errorParamSet();
        }

        public ngAfterViewInit() {
               let labelCtrl = this.elRef.nativeElement.querySelector('label');
               super.layoutFromViewInit(labelCtrl.parentElement);
        }

        public onDateChange() {

              this.input = (this.YY||0) + "-" + (this.MM||0) + "-" + (this.DD||0);

              if ( this.input == "0-0-0" ) 
                   this.input = "";

              super.valueChanged();

              this.changeHandler.emit(this.input);
              
              /**
              let  isValid = Util._isValidDate(Number(this.MM), Number(this.DD), this.YY);

              if ( isValid == false || this.YY >= 1000 && this.YY < 1900 ) 
                   this.inputStyle = "color:red";
              else 
                   this.inputStyle = "color:black";
                    */
        }
}

